import { createBasicSelector } from 'util/redux'
import { base } from './base'

export const selectPageComponentName = createBasicSelector(
  base,
  page => page.componentName
)
